import { useEffect, type ReactNode } from "react";
import { createPortal } from "react-dom";

/* Checkout modal (OPSS-55). Purpose-built rather than the design-system Dialog
 * because Stigg's checkout is tall — it needs a wider panel with its own vertical
 * scroll (the shared Dialog caps at ~512px and doesn't scroll, so the form
 * overflowed the viewport). */
export function CheckoutModal({
  open,
  onClose,
  children,
}: {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}) {
  useEffect(() => {
    if (!open) return;

    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto p-4 sm:p-8">
      <div
        className="absolute inset-0 bg-grey-1000/40"
        aria-hidden
        onClick={onClose}
      />
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Complete your subscription"
        className="relative my-auto w-full max-w-5xl rounded-lg border bg-surface p-6 shadow-lg"
      >
        {children}
      </div>
    </div>,
    document.body,
  );
}
